// W-0560 — Mensagens literais da tela Reapresentação de Cheques (ADR-005).
// Fonte: PRD §5.3 + UReaprChDv.pas (MessageDlg/ShowMessage). Não improvisar tradução.

export const MODO_NUMERO = 'numero';
export const MODO_CEDENTE = 'cedente';
export const MODO_BANCO_AGENCIA = 'banco_agencia_conta_numero';

// Enum ModoBuscaCheque do backend (TechSpec §2.2):
// Numero=1, Cedente=2, BancoAgenciaContaNumero=3.
export const MODO_BACKEND = {
  [MODO_NUMERO]: 1,
  [MODO_CEDENTE]: 2,
  [MODO_BANCO_AGENCIA]: 3,
};

export const mensagens = {
  // Toasts
  GE_OBRIGATORIA: 'Escolha um grupo de empresa!',
  NENHUM_PARAMETRO: 'Nenhum Parametro informado',
  CHEQUE_JA_REAPRESENTADO: 'Cheque já reapresentado 2 vezes.',
  CHEQUE_JA_ADICIONADO: 'Este cheque já está no carrinho.',
  ALINEA_INVALIDA: 'Alinea Nª Dev não passível de reapresentação.',
  CARRINHO_VAZIO: 'Adicione ao menos um cheque ao carrinho.',
  LIMITE_LOTE:
    'Limite de 500 cheques por processamento. Divida em lotes menores.',
  CONTA_DEPOSITO_NULA: 'A conta para depósito não pode conter valor nulo.',
  CONTA_DEPOSITO_INVALIDA: 'Conta para depósito inválida!',
  GE_SEM_CONTA_JUROS:
    'GE selecionada não tem conta de juros de reapresentação configurada. Contate o cadastro.',
  ERRO_BUSCA: 'Erro ao buscar cheques.',
  ERRO_PROCESSAMENTO: 'Erro ao processar cheques.',
  PROCESSAMENTO_OK: 'Processamento concluído.',
  PROCESSAMENTO_PARCIAL:
    'Processamento parcial: alguns cheques foram pulados ou falharam.',

  // Modais Confirm
  CONFIRMAR_VENCIMENTO_FUTURO: 'Favor Verificar data de Vencimento!',
  CONFIRMAR_CANCELAR_TODOS: 'Cancelar todos os cheques do carrinho?',
  CONFIRMAR_TROCAR_GE: 'O carrinho atual será limpo. Continuar?',
  CONFIRMAR_REMOVER_CHEQUE: 'Remover este cheque do carrinho?',
};

export default mensagens;
